import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import * as Yup from 'yup';
import { Form } from 'formik';
import { FormikDebounce } from '../../../common/form/FormikDebounce';
import { FormContainer } from '../../../common/form/FormContainer';
import { validations } from '../../../../utils/validations';
import { SubmitButton } from '../../../common/form/SubmitButton';
import { ActivityAutocomplete } from '../../../common/form/ActivityAutocomplete';
import { invitationGetUpdateDto, useInvitation } from './invitationFunctions';
import { ActivityDto } from '@api/models/activity/ActivityDto';
import { invitationService } from '@api/services/services';
import { ShowError } from '../../../ShowError';
import { resources } from '@api/resources';

interface ActivityAddModalForm {
  activities: ActivityDto[];
}

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ActivityAddModal: FC<Props> = ({ open, onClose }) => {
  const { t, invitation, callWithLock, reloadInvitation } = useInvitation();

  const handleSubmit = async (data: ActivityAddModalForm) => {
    await callWithLock(async () => {
      const data2 = invitationGetUpdateDto(invitation);
      const data3 = {
        ...data2,
        activities: [
          ...data2.activities,
          ...data.activities?.map((x) => ({
            id: x.id!,
            name: x.name,
            nameEn: x.nameEn,
          })),
        ],
      };

      await invitationService.update(invitation.id!, data3);
      await reloadInvitation();

      onClose();
    });
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="activity.add" />
        <FormikDebounce<ActivityAddModalForm>
          initialValues={{
            activities: [],
          }}
          validationSchema={Yup.object().shape({
            activities: validations.arrayNotEmpty(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <ActivityAutocomplete
                name="activities"
                label={t('invitation.activity.name')}
                required
                excludeIds={invitation.activities?.map((x) => x.activity?.id ?? '')}
                multiple
                showCertificates
              />
              <ShowError resource={resources.updateInvitation} />
              <SubmitButton resourceLoading={resources.updateInvitation} />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
